import { inject, Service } from '@angular/core';
import { Resolve } from '@angular/router';
import { Owner } from '@h5s/entities';
import { defer, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FeatureOwnerService } from '../feature-owner.service';

/**
 * Resolver per caricare le impostazioni dell'Owner prima di attivare le rotte che ne fanno uso.
 * Se le impostazioni sono già caricate, non fa nulla.
 * Se non sono caricate, chiama il metodo loadOwnerSettings() del FeatureOwnerService.
 */
@Service()
export class OwnerResolver implements Resolve<Owner> {
  /** Services */
  private readonly featureOwnerService = inject(FeatureOwnerService);

  resolve(): Observable<Owner> {
    return defer(() => {
      const owner = this.featureOwnerService.ownerSettings();
      if (this.isValidOwner(owner)) return of(owner);

      return this.featureOwnerService
        .loadOwnerSettings()
        .pipe(switchMap(() => of(this.featureOwnerService.ownerSettings())));
    });
  }

  /**
   * Verifica se le impostazioni dell'Owner sono valide
   */
  private isValidOwner(owner: Owner): boolean {
    return !!owner && !!owner.id;
  }
}
